import {translations} from 'presentation/translations-new';
import {ChatRoomsEnum} from 'presentation/constants';
import {useContractStatus, useHostName} from 'presentation/hooks';

import {useAccountInformation, useCallChatRoom} from 'presentation/pages/private/hooks';

import {useFinancialSupport} from 'presentation/pages/private/hooks/useFinancialSupport';
import {UseChatLinksParams, ChatLink} from './types';

const {modal} = translations['pt-br'].privateFlow.help.contactUs;
const {iFrameTitle: teaTitle, modalDescription} =
	translations['pt-br'].privateFlow.bookingFlow.specialtyFlow.teaFlow;

export function useChatLinks({teaFormProps}: UseChatLinksParams) {
	const {isResponsibleWithoutBenefits, odontoOnly} = useAccountInformation();
	const {canShowFinancialSupport, financialSupportWhatsappLink} = useFinancialSupport();
	const {isValid} = useContractStatus();
	const {isGndiSaoPaulo} = useHostName();
	const {callChatRoom, IS_LOADING: isChatRoomLoading} = useCallChatRoom();
	const canShowTea = isValid && isGndiSaoPaulo && !isResponsibleWithoutBenefits && !odontoOnly;
	const isLoading = isChatRoomLoading || teaFormProps.isFetching;

	const allChatLinks: ChatLink[] = [
		{
			title: modal.whatsapp.title,
			description: modal.whatsapp.description,
			onClick: () => callChatRoom(ChatRoomsEnum.SAC),
			isLoading: isChatRoomLoading,
			show: isValid,
		},
		{
			title: teaTitle,
			description: modalDescription,
			onClick: teaFormProps.handleGoToTeaForm,
			isLoading: teaFormProps.isFetching,
			show: canShowTea,
		},
		{
			title: modal.financialSupport.title,
			description: modal.financialSupport.description,
			onClick: () =>
				window.open(financialSupportWhatsappLink, '_blank', 'noopener,noreferrer'),
			show: canShowFinancialSupport,
		},
	];

	const chatLinks = allChatLinks.filter(link => link.show);

	return {
		chatLinks,
		isLoading,
	};
}
